import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
const initialState = {
	specialistList: [],
	specialistDetails: [],
	experienceList: {},
	subSpecializationList: [],
	appointments: [],
	dayappointments: [],
	stateList: [],
	specialistProfile: [],
	searchkey: {},
	zipcodeInfo: {},
	clinicInfo: [],
	otherConsultationAddress: [],
	specialistPatients: [],
	myFeedback: {},
	myFeedbackDetail: [],
	successMsg: '',
	stripeDetails: {},
	countryList: [],
	specialistBlockings: [],
	specialistPasswordChangeSuccess: false,
	specialistEmailChangeSuccess: false,
	conditionalProcedureMappingList: [],

	
	// specializationList: []
};

export default function specialistReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_SPECIALISTS_LIST:
			return {
				...state,
				specialistSearchSuccess: true,
				specialistList: action.specialistList,
				searchkey: action.searchkey
			};
		case types.GET_SPECIALISTS_ASSISTANT_LIST:
			// debugger;
			return {
				...state,
				specialistListAssistant: action.specialistListAssistant,
				searchkey: action.searchkey
			};
		case types.GET_SPECIALIST_DETAIL:
			return {
				...state,
				specialistDetails: action.specialistDetails
			};
		case types.GET_SPECIALIZATION_LIST:

			return {
				...state,
				specializationList: action.specializationList
			};

		case types.GET_EXPERIENCE_LIST:
			return {
				...state,
				experienceList: action.experienceList
			};

		case types.GET_SUBSPECIALIZATION_LIST:
			return {
				...state,
				subSpecializationList
					: action.subSpecializationList

			};
		case types.GET_APPOINTMENTS_FOR_MONTH:
			return {
				...state,
				appointments: action.appointments
			};
		case types.GET_QUESTION_RATING:
			return {
				...state,
				questionRatings: action.questionRatings
			};
		case types.ADD_CURRENCY_FILTER:
			return {
				...state,
				currencyFilter: action.currencyFilter
			};
		case types.LIST_CURRENCY_FILTER:
			return {
				...state,
				listcurrencyFilter: action.listcurrencyFilter
			};
		case types.GET_APPOINTMENTS_FOR_DAY:
			return {
				...state,
				dayappointments: action.dayappointments
			};
		case types.GET_COUNTRIES_LIST:
			return {
				...state,
				countryList: action.countryList
			};

		case types.GET_STATES_LIST:
			return {
				...state,
				stateList
					: action.stateList
			};


		case types.GET_SPECIALIST_PROFILE:
			return {
				...state,
				specialistProfile
					: action.specialistProfile
			};


		case types.CHECK_ZIPCODE:
			return {
				...state,
				zipcodeInfo
					: action.zipcodeInfo
			};

		case types.GET_AVAILABILITY:
			return {
				...state,
				clinicInfo
					: action.clinicInfo,
				successMsg: action.successMsg
			};

		case types.GET_SPECIALIST_PATIENTS:
			
			return {
				...state,
				specialistPatients
					: action.specialistPatients
			};

		case types.GET_OTHER_CONSULTATION_ADDRESS:
			return {
				...state,
				otherConsultationAddress
					: action.otherConsultationAddress
			};

		case types.GET_MY_FEEDBACK:
			return {
				...state,
				myFeedback
					: action.myFeedback
			};

		case types.GET_MY_FEEDBACK_DETAIL:
			return {
				...state,
				myFeedbackDetail
					: action.myFeedbackDetail
			};

		case types.GET_SPECIALIST_STRIPE_DETAILS:
			return {
				...state,
				stripeDetails
					: action.stripeDetails
			};
		case types.GET_CONVERTED_CURRENCY:
			return {
				...state,
				convertedCurrency
					: action.convertedCurrency
			};
		case types.SEARCH_COMPLETE:
			return {
				...state,
				specialistSearchSuccess: false,
			};
		case types.GET_SPECIALIST_DETAIL_FOR_BLOCK:
			return {
				...state,
				specialistDetail: action.specialistDetail,
			};
		case types.GET_SPECIALIST_BLOCKINGS:
			return {
				...state,
				specialistBlockings: action.specialistBlockings,
			};
		case types.SPECIALIST_DETAIL_FOR_APPOINTMENT:
			return {
				...state,
				specialistDetailForAppointment: action.specialistDetailForAppointment,
			};
		case types.SPECIALIST_PASSWORD_CHANGE_SUCCESS:
			return {
				...state,
				specialistPasswordChangeSuccess: true,
			};
		case types.RESET_SPECIALIST_PASSWORD_CHANGE_SUCCESS:
				return {
				...state,
				specialistPasswordChangeSuccess: false,
				};	
		case types.SPECIALIST_EMAIL_CHANGE_SUCCESS:
			return {
				...state,
				specialistEmailChangeSuccess: true,
			};
		case types.RESET_SPECIALIST_EMAIL_CHANGE_SUCCESS:
				return {
				...state,
				specialistEmailChangeSuccess: false,
				};
		case types.GET_CONDITIONAL_PROCEDURE_MAPPING_LIST:
				return {
				...state,
				conditionalProcedureMappingList
				: action.conditionalProcedureMappingList
		
				};		
			
		default:
			// return initialState;
			return state;
	}
}
